/** Grafiskt element i hero: bron mellan strategi, affär, teknik och resultat. */
export default function HeroArt() {
  return (
    <div className="hero-art" aria-hidden="true">
      <div className="bridge">
        <div className="node n1">STRATEGI</div>
        <div className="node n2">AFFÄR</div>
        <div className="node n3">TEKNIK</div>
        <div className="node n4">RESULTAT</div>
        <div className="line l1" />
        <div className="line l2" />
        <div className="line l3" />
      </div>
    </div>
  );
}
